export const PROFILE_URL = '/user_profile';